<script setup lang="ts">
import {
  computed,
  ref,
} from 'vue';

import type { VFormFilesInputProps } from '@modules/forms/components/inputs/VFormFilesInput/types';
import VFormFilesInput from '@modules/forms/components/inputs/VFormFilesInput/VFormFilesInput.vue';
import { watchImmediate } from '@vueuse/core';

import type {
  VFormSingleFileInputEmits,
  VFormSingleFileInputProps,
} from './types';

const props = withDefaults(defineProps<VFormSingleFileInputProps>(), {});
const emit = defineEmits<VFormSingleFileInputEmits>();

const innerValue = ref<File[]>([]);

const filesInputProps = computed<VFormFilesInputProps>(() => ({
  ...props,
  value: innerValue.value,
  fileLimit: 1,
  renameFiles: false,
}));

function getFile(files?: File[]): File | undefined {
  return files && files.length > 0 ? files[0] : undefined;
}

watchImmediate(() => props.value, (newValue) => {
  innerValue.value = newValue ? [newValue] : [];
}, { deep: true });
</script>

<template>
  <VFormFilesInput v-data-qa-auto-id="'VFormSingleFileInput'"
    v-bind="filesInputProps"
    @upload="emit('upload', getFile($event))"
    @input="emit('input', getFile($event))"
    @change="emit('change', getFile($event))"
    @focus="emit('focus', getFile($event))"
    @blur="emit('blur', getFile($event))"
    @error="emit('error', $event)"
  />
</template>
